var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Flow',{attrs:{"flowName":_vm.getName(),"exitForward":_vm.exitForward,"exitBack":_vm.exitBack,"initialLoading":_vm.initialLoading},on:{"flow-loaded":_vm.onFlowLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }